import http from '../utils/http';

const API_URL = '/contratos/resources';

export const resourceService = {
    // Get all resources or filter by category
    getResources: async (category = null) => {
        const params = category ? { category } : {};
        const response = await http.get(API_URL, {
            params
        });
        return response.data;
    },

    // Upload a new resource
    uploadResource: async (formData) => {
        const response = await http.post(API_URL, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    },

    // Update resource metadata
    updateResource: async (id, data) => {
        const response = await http.patch(`${API_URL}/${id}`, data);
        return response.data;
    },

    // Delete resource
    deleteResource: async (id) => {
        await http.delete(`${API_URL}/${id}`);
    },

    // Get the latest active release note configured as modal
    getLatestRelease: async () => {
        const response = await http.get(`${API_URL}/latest-release`);
        return response.data;
    }
};
